import {coordsToKey} from "../coords/coordsToKey";
import {HEX_DIRECTIONS} from "../../constants/geometry";
import {isHexTokenIsBlockerForMovement} from "../movement/isHexTokenIsBlockerForMovement";

/**
 * Вычисляет доступные для маневра ячейки для указанного отряда
 * Маневр позволяет переместить отряд на 1 смежную ячейку, если там нет других отрядов
 * @param {Object} hexGridRenderer - инстанс HexGridRenderer
 * @param {Object} hexes - состояние ячеек поля
 * @param {Array} units - все отряды на поле
 * @param {Object} selectedUnit - выбранный отряд для маневра
 * @param {Array<string>} noStopHexKeys - ячейки, на которые вставать нельзя:
 *   на них на этом этапе погиб отряд от ловушек Гоблинов и показан до конца
 *   этапа (см. selectGoblinsTrapDeathHexKeys)
 * @returns {Array} массив ключей доступных ячеек
 */
export const calculateAvailableManeuverCells = (hexGridRenderer, hexes, units, selectedUnit, noStopHexKeys = []) => {
  const noStopHexKeysSet = new Set(noStopHexKeys);
  const { hexKey } = selectedUnit;
  const [startQ, startR] = hexKey.split(',').map(Number);

  const availableCells = [];

  // Проверяем все 6 смежных направлений
  for (const [dq, dr] of HEX_DIRECTIONS) {
    const newQ = startQ + dq;
    const newR = startR + dr;
    const newKey = coordsToKey(newQ, newR);

    // Проверяем что ячейка существует на поле
    if (!hexGridRenderer.hexes[newKey]) {
      continue;
    }

    if(isHexTokenIsBlockerForMovement(hexes[newKey])) {
      continue;
    }

    // Проверяем что на ячейке нет других отрядов
    const unitOnCell = units.find(u => u.hexKey === newKey);
    if (unitOnCell) {
      continue;
    }

    // На ячейке показан погибший от ловушки отряд — встать некуда
    if (noStopHexKeysSet.has(newKey)) {
      continue;
    }

    // Ячейка доступна для маневра
    availableCells.push(newKey);
  }

  return availableCells;
};
